import { GroupBase, OptionProps, components } from 'react-select';
import { Checkbox } from 'src/components/atoms';
import type { UserType } from 'src/graphql';
import { returnDashIfNoValue } from 'src/utils';
import {
  InviteUserOptionStyled,
  UserDetailsText,
  UserNameText,
} from './InviteUserOption.styles';

export interface EmployeeDirectoryFieldOptionData {
  label: string;
  value: string;
  user: UserType;
  role?: string | null;
  department?: string | null;
  country?: string | null;
}

export const EmployeeDirectoryFieldOption = (
  props: OptionProps<
    EmployeeDirectoryFieldOptionData,
    boolean,
    GroupBase<EmployeeDirectoryFieldOptionData>
  >,
) => {
  const { isMulti } = props.selectProps;
  const role = returnDashIfNoValue(props.data.role);
  const department = returnDashIfNoValue(props.data.department);
  const country = returnDashIfNoValue(props.data.country);

  return (
    <components.Option {...props}>
      <InviteUserOptionStyled
        data-testid={`employee-directory-option-${props.data.value}`}
      >
        {isMulti && (
          <Checkbox
            checked={props.isSelected}
            onChange={() => {}}
            variant="default"
          />
        )}
        <UserNameText title={props.label}>
          {returnDashIfNoValue(props.label)}
        </UserNameText>
        <UserDetailsText title={role}>{role}</UserDetailsText>
        <UserDetailsText title={department}>{department}</UserDetailsText>
        <UserDetailsText title={country}>{country}</UserDetailsText>
      </InviteUserOptionStyled>
    </components.Option>
  );
};
